<section>
  <div class="header">
    <h1>{{ 'SEND_TENANT_MAIL_LIST.HEADER' | translate }}</h1>
  </div>
  <app-information-block [text]="'MAIL_LIST.HELP_DESCRIPTION' | translate"></app-information-block>
  <app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>
  @if (itemsSource) {
    <app-paged-list-view
      [columnDefinition]="columnDefinition"
      [itemsSource]="itemsSource"
      [contextMenuDefinition]="contextMenuDefinition"
      [menuDefinition]="menuDefinition"
      (rowClick)="onRowClicked($event)"
      [isToolbarSticky]="true"
      (onPageChange)="pagingChanged($event)"
      (onSortChange)="sortChanged($event)"
      [preferencesKey]="preferencesKey"
      [totalCount]="totalResults"
      >
    </app-paged-list-view>
  }
</section>
